import { createContext, useContext } from 'react';

// Define specific error types
export enum MediaDeviceErrorType {
  NO_PERMISSIONS = 'NO_PERMISSIONS',
  DEVICE_NOT_FOUND = 'DEVICE_NOT_FOUND',
  INITIALIZATION_ERROR = 'INITIALIZATION_ERROR',
}

export interface MediaDeviceError {
  type: MediaDeviceErrorType;
  message: string;
}

export interface MediaDeviceState {
  cameras: MediaDeviceInfo[];
  microphones: MediaDeviceInfo[];
  speakers: MediaDeviceInfo[];
  selectedCamera: string;
  selectedMicrophone: string;
  selectedSpeaker: string;
  stream: MediaStream | null;
  error: MediaDeviceError | null;
  analyser: AnalyserNode | null;
  isVideoEnabled: boolean;
  isAudioEnabled: boolean;
  isRequestingPermissions: boolean;
  checkMediaDevicePermissions: () => Promise<boolean>;
  setSelectedCamera: (deviceId: string) => void;
  setSelectedMicrophone: (deviceId: string) => void;
  setSelectedSpeaker: (deviceId: string) => void;
  toggleVideo: () => void;
  toggleAudio: () => void;
}

export const MediaDevicesContext = createContext<MediaDeviceState | undefined>(
  undefined,
);

export const useMediaDevicesContext = () => {
  const context = useContext(MediaDevicesContext);
  if (context === undefined) {
    throw new Error(
      'useMediaDevicesContext must be used within a MediaDevicesProvider',
    );
  }
  return context;
};
